import { render, staticRenderFns } from "./ProfileListing.vue?vue&type=template&id=189ef4f3&"
import script from "./ProfileListing.vue?vue&type=script&lang=js&"
export * from "./ProfileListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports